// import { useCruiseMapStore } from "@/store/cruise-map";
import dayjs from "dayjs";
import { getAisCruiseTrajectory } from "@/services/company"
import { ref, watch, watchEffect } from "@nuxtjs/composition-api";

export default function useCruiseTrajectory(bmapRef, cruiseData, cruise_id) {
    const showRoute = ref(false);
    // const trajectorySearchData = ref({
    //     time_start: '',
    //     time_end: ''
    // })
    const trajectorySearchData = ref([])
    const lineLayerRef = ref();
    const labelLayerRef = ref();

    function onLineLayerReday(inst, trajectory = []) {
        drawLine(trajectory)
        setViewport(trajectory)
        // setLabel(trajectory);
    }


    function createPoint(point) {
        return new window.BMap.Point(point.longitude, point.latitude);
    }

    function makeLineData(points) {
        return [
            {
                geometry: {
                    type: "LineString",
                    coordinates: points.map((point) => [point.longitude, point.latitude]),
                },
            },
        ];
    }

    function drawLine(points = []) {
        lineLayerRef.value.setData(makeLineData(points));
    }

    function setViewport(points) {
        const viewport = bmapRef.value.getViewport(
            points.map((point) => createPoint(point))
        );
        bmapRef.value.setViewport(viewport);
    }

    function setLabel(points) {
        labelLayerRef.value.setData(makeLabelData(points).reverse());
    }

    // const store = useCruiseMapStore();
    const store = {}
    watchEffect(async () => {
        const [time_start = '', time_end = ''] = trajectorySearchData.value || [];

        if (time_start && time_end && lineLayerRef.value) {
            getAisCruiseTrajectory({
                time_start,
                time_end,
                // id: cruiseData.value.cruise_id
                id: cruise_id
            }).then(({ data = [] }) => {
                // console.log('getAisCruiseTrajectory', data)
                drawLine(data)
                setViewport(data);
                setLabel(data);
            })
        }
    })
    // watch((vaiue) => {
    //     console.log({vaiue}, 'vaiuevaiue')
    // }, showRoute)



    function onLabelLayerReday(inst, cruiseData = []) {
        // console.log('onLabelLayerReday', cruiseData)
        setLabel(cruiseData);
    }

    function makeLabelData(points) {
        return points.map((point) => {
            return {
                geometry: {
                    type: "Point",
                    coordinates: [point.longitude, point.latitude],
                },
                fillStyle: 'red', // 点数据时候使用
                strokeStyle: 'red', // 线数据时候使用
                properties: {
                    text: dayjs(point.create_time).format("YYYY-MM-DD HH:mm"),
                },
            };
        });
    }
    return {
        showRoute,
        trajectorySearchData,

        lineLayerRef,
        labelLayerRef,

        onLineLayerReday,

        onLabelLayerReday
    }
}
